export default __webpack_public_path__ + "static/media/046-u-turn.0ce7c2dd.png";